export enum NotificationType {
  critical = 'critical',
  error = 'error',
  warning = 'warning',
  success = 'success',
  info = 'info',
  alert = 'alert',
}

export enum NotificationStyle {
  pending_transactions = 'pending-transactions',
}

interface NotificationTime {
  start: string;
  end?: string;
  duration?: string;
}

export interface Notification {
  id: string;
  title: () => string;
  // tslint:disable-next-line
  type: NotificationType;
  time?: NotificationTime;
  description: () => string;
  steps?: () => string[];
  priority: number;
  style?: NotificationStyle;
  action?: Object;
}

export interface ModalNotification extends Notification {
  button?: NotificationButton;
  cloudSyncMessage?: () => string;
  titleModal?: () => string;
  tooltip?: string;
}

export interface NotificationButton {
  name: string;
  action: MODAL_NOTIFICATION_BUTTON_ACTIONS;
}

export enum MODAL_NOTIFICATION_IDS {
  FAIL_CONFIG_DOWNLOAD_ID = 'failConfigDownload',
  PAYMENT_DEVICE_NOTIFICATION_ID = 'paymentTerminalUnavailable',
  PAYMENT_DEVICE_NOTIFICATION_FOR_VERIFONE_ID = 'paymentTerminalUnavailableForVerifone',
  PAYMENT_DEVICE_RECOGNIZED_NOTIFICATION_ID = 'paymentTerminalRecognized',
  NO_INTERNET_CONNECTION_ID = 'noInternetConnection',
  NO_NETWORK_CONNECTION_ID = 'noNetworkConnection',
  NO_XKM_CONNECTION_ID = 'noXKMConnection',
  TIME_DISCREPANCY_NOTIFICATION_ID = 'incorrectSystemTime',
  TERMINAL_UNAVAILABLE_ID = 'terminalUnavailable',
  TERMINAL_REFRESH_ID = 'terminalRefresh',
  CONFIG_REFRESH_ID = 'configRefresh',
  APP_REFRESH_ID = 'appRefresh',
  ONLINE_ORDERS_DISABLED_NOTIFICATION_ID = 'onlineOrdersDisabled',
  PENDING_TRANSACTIONS_ID = 'pendingTransactions',
  COIN_DISPENSER_IS_NEARLY_EMPTY_ID = 'coinDispenserIsNearlyEmpty',
  COIN_DISPENSER_UNAVAILABLE_ID = 'coinDispenserUnavailable',
}

export enum MODAL_NOTIFICATION_BUTTON_ACTIONS {
  PAIR_VERIFONE_DEVICE = 'pairVerifoneDevice',
}
